<template>
  <!-- 接单 -->
  <div class="create-order">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      class="rule-content"
    >
      <titleBlock class="title_bar" title="仓配一体自动接单设置">
        <div class="text-wrapper">
          <span class="text1">自动接单</span>
          <span class="text2">开启后仓配一体自动接单，关闭后需要手动接单</span>
        </div>
        <el-switch
          v-model="form.AUTO_DEAL.warehouseFlag"
          active-color="#059E84"
          inactive-color="#D9DBDE"
        />
      </titleBlock>
      <titleBlock class="title_bar" title="运营项目卡控">
        <div class="text-wrapper">
          <span class="text2">开启配置后，订单接单将强校验运营项目，不允许为空</span>
        </div>
        <el-switch
          v-model="form.AUTO_DEAL.projectFlag"
          active-color="#059E84"
          inactive-color="#D9DBDE"
        />
      </titleBlock>
      <titleBlock class="title_bar" title="接单设置">
        <div class="text-wrapper">
          <span class="text1">自动接单</span>
          <span class="text2">开启后订单自动接单，关闭后需要手动接单</span>
        </div>
        <el-switch
          v-model="form.AUTO_DEAL.flag"
          active-color="#059E84"
          inactive-color="#D9DBDE"
        />
        <addCondition
          v-if="form.AUTO_DEAL.flag"
          ref="AddCondition"
          class="Receiving"
          :condition-list.sync="form.AUTO_DEAL_CONDITION.condition"
          validate-string="AUTO_DEAL_CONDITION.condition"
          :tips="form.AUTO_DEAL.flag?'自动接单,不满足条件就手动接单':'手动接单,不满足条件就自动接单'"
          type="receiving"
          :condition-type="conditionType"
          :condition-kind="CONDITION_KIND"
          @addOrCondition="addOrCondition"
          @addAdnCondition="addAdnCondition"
          @delete="Delete"
          @orDelete="handleOrDelete"
          @clearValidate="clearValidate"
        />
      </titleBlock>
      <titleBlock title="超时处理" more-info="流程到达节点超时触发后将自动取消">
        <el-switch
          v-model="form.DEAL_OVER_TIME.flag"
          active-color="#059E84"
          inactive-color="#D9DBDE"
        />
        <span class="switch_tips">开启时流程到达节点超时触发后将自动取消，关闭后不会自动取消。</span>
        <div v-if="form.DEAL_OVER_TIME.flag" class="new-flex">
          <div class="second-title required">
            流程到达该节点
          </div>
          <el-form-item
            class="overTime_trigger"
            prop="DEAL_OVER_TIME_CONDITION.fieldName"
          >
            <div class="receiving_time flex align-center">
              <div class="flex align-center">
                <el-select
                  v-model="form.DEAL_OVER_TIME_CONDITION.fieldName"
                  placeholder="请选择"
                  class="receivingTimeType"
                >
                  <el-option
                    v-for="item in receivingTimeType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-select v-model="form.DEAL_OVER_TIME_CONDITION.action" class="receivingTimeTypeUnit">
                  <el-option
                    v-for="item in receivingStsgeType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="DEAL_OVER_TIME_CONDITION.num">
            <div class="time_input flex align-center">
              <el-input v-model="form.DEAL_OVER_TIME_CONDITION.num" placeholder="请输入" />
              <el-select v-model="form.DEAL_OVER_TIME_CONDITION.unit">
                <el-option
                  v-for="item in timeUnit"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <span v-if="form.overTimeTrigger!==OVERTIME_TYPE.BASIS_TABLE_FIELD" class="basis">后</span>
            </div>
          </el-form-item>
        </div>
      </titleBlock>
      <titleBlock
        ref="timeoutNotification"
        class="title_bar"
        title="接单任务预警"
      >
        <div class="flex align-center marginBottom ">
          <el-switch
            v-model="form.DEAL_NOTIFY.enableNotify"
            active-color="#059E84"
            inactive-color="#D9DBDE"
          />
          <span class="switch_tips">开启后通过消息提醒客户及时接单</span>
        </div>
        <div v-if="form.DEAL_NOTIFY.enableNotify" class="new-flex">
          <el-form-item
            prop="DEAL_NOTIFY.timeDimension"
            label="预警时间"
            label-width="90px"
            :rules="[{ required: true, message: '请选择预警时间', trigger: 'change' }]"
          >
            <el-select
              v-model="form.DEAL_NOTIFY.timeDimension"
              placeholder="请选择"
              class="receivingTimeType"
            >
              <el-option
                v-for="item in notifyTimeType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            prop="DEAL_NOTIFY.operator"
            :rules="[{ required: true, message: '请选择', trigger: 'change' }]"
          >
            <el-select v-model="form.DEAL_NOTIFY.operator" class="receivingTimeTypeUnit">
              <el-option
                v-for="item in receivingStsgeType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            prop="DEAL_NOTIFY.number"
            :rules="[
              { required: true, message: '请输入', trigger: 'blur' },
              { pattern:/^([0-9]|[1-9][0-9])$/, message: '请输入正确的数字', trigger: 'blur' },
            ]"
          >
            <el-input v-model="form.DEAL_NOTIFY.number" placeholder="请输入" />
          </el-form-item>
          <el-form-item prop="DEAL_NOTIFY.unit" :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
            <el-select v-model="form.DEAL_NOTIFY.unit">
              <el-option
                v-for="item in notifyTimeUnit"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="basis">后</span>
          </el-form-item>
        </div>
        <timeoutNotification
          v-if="form.DEAL_NOTIFY.enableNotify"
          :form="form.DEAL_NOTIFY"
          :fields="receiveOrderTimeoutNotification"
        />
      </titleBlock>
    </el-form>
  </div>
</template>

<script>
import { processingSelectData } from '@/utils/index';
import titleBlock from '../assembly/titleBlock.vue';
import {
  TIME_UNIT,
  timeReg,
  RECEIVING_TIME_TYPE,
  RECEIVING_STSGE_TYPE,
  OVERTIME_TYPE,
  CONDITION_TYPE_MAP,
  CONDITION_KIND,
  receiveOrderTimeoutNotification,
  NOTIFY_TIME_TYPE,
} from './const';
import addCondition from './addCondition.vue';
import timeoutNotification from './timeoutNotification.vue';

export default {
  components: { titleBlock, addCondition, timeoutNotification },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const validateTime = (rule, value, callback) => {
      if (!timeReg.test(Number(value))) {
        callback('请输入正确的时间');
      }
      callback();
    };
    return {
      receiveOrderTimeoutNotification,
      OVERTIME_TYPE,
      CONDITION_KIND,
      module: 'DEAL',
      rules: {
        'AUTO_DEAL.flag': [
          { required: true, message: '请选择接单设置', trigger: 'change' },
        ],
        'DEAL_OVER_TIME_CONDITION.fieldName': [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        'DEAL_OVER_TIME_CONDITION.num': [
          { required: true, validator: validateTime, trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    timeUnit() {
      return processingSelectData(TIME_UNIT);
    },
    receivingTimeType() {
      return processingSelectData(RECEIVING_TIME_TYPE);
    },
    receivingStsgeType() {
      return processingSelectData(RECEIVING_STSGE_TYPE);
    },
    conditionType() {
      const { ASSIGNED, ROOT_CUSTOMER_NAME } = CONDITION_TYPE_MAP;
      return processingSelectData({ ASSIGNED, ROOT_CUSTOMER_NAME });
    },
    notifyTimeType() {
      return processingSelectData(NOTIFY_TIME_TYPE);
    },
    notifyTimeUnit() {
      return processingSelectData({ ...TIME_UNIT, MINUTE: '分钟' });
    },
  },
  watch: {
    // 'form.AUTO_DEAL.flag': {
    //   handler(flag) {
    //     if (flag && !this.form.AUTO_DEAL_CONDITION.condition.length) {
    //       this.addOrCondition();
    //     }
    //   },
    //   immediate: true,
    // },
  },
  methods: {
    async valiForm() {
      await this.$refs.form.validate();
      let data = Object.keys(JSON.parse(JSON.stringify(this.form)));
      if (!this.form.DEAL_OVER_TIME.flag) {
        data = data.filter((item) => item !== 'DEAL_OVER_TIME_CONDITION');
      }
      const res = data.map((item) => ({ ruleCode: item, ruleValue: this.form[item] }));
      return {
        form: this.form,
        res,
      };
    },
    clearValidate(prop) {
      this.$refs.form.clearValidate(prop);
    },
    addOrCondition() {
      this.$emit('addOrCondition', this.module, 'AUTO_DEAL_CONDITION');
    },
    addAdnCondition(index) {
      this.$emit('addAdnCondition', index, this.module, 'AUTO_DEAL_CONDITION');
    },
    Delete(value) {
      this.$emit('delete', value, this.module, 'AUTO_DEAL_CONDITION');
    },
    handleOrDelete(value) {
      this.$emit('OrDelete', value, this.module, 'AUTO_DEAL_CONDITION');
    },
  },
};
</script>

<style lang="scss" scoped>
.create-order{
  box-sizing: border-box;
  padding:0 24px 24px;
  padding-bottom: 40px;
  ::v-deep .title_bar{
    border-bottom: 1px solid #D9DBDE;
  }
  .title-block{
    padding-top:24px;
  }
  ::v-deep .el-switch{
    margin:8px 0 12px;
  }
  .text-wrapper{
    display:flex;
    align-items: center;
    .text1{
      font-size: 14px;
      color:#404B5C;
    }
    .text2{
      font-size: 13px;
      color:#808792;
      margin-left:8px;
    }
  }
  .new-flex{
    display:flex;
    flex-wrap:wrap;
    .second-title{
      color:#404B5C;
      margin-bottom:8px;
      width:100%;
    }
    ::v-deep .el-form-item{
      margin-right:16px;
      .el-select{
        margin-right:8px;
      }
      .el-input{
        margin-right:8px;
      }
    }
  }
  .required:before{
    content:'*';
    color:red;
  }
}
.marginBottom{
  margin:8px 0 24px;
}
.switch_tips{
  margin-left:12px;
  font-size: 13px;
  color:#808792;
}
</style>
